import Player from '@components/player'

const routes = [
    {
        path: "/:preset_id?",
        component: Player
    },
];

export default routes;